import { defineStore } from 'pinia';
import { ref } from 'vue';
import { TAdmin } from '@/types/admin';

export const useAdminStore = defineStore('admin', () => {
  const admin = ref<TAdmin>({} as TAdmin);

  return {
    admin,
  };
});
